import { Option } from '../types/common-types'
import { PassportType } from '../enums/passportTypeEnum'

export const passportTypeKz: Option[] = [
  {
    value: PassportType.IdentityCard,
    label: {
      eng: 'Identification',
      rus: 'Уд. личности',
      kz: 'Жеке куәлік',
    },
  },
]

export const passportTypeRfForKz: Option[] = [
  //   {
  //     value: PassportType.InternationalPassport,
  //     label: {
  //       eng: 'International passport',
  //       rus: 'Заграничный паспорт',
  //       kz: 'Шетелдік төлқұжат',
  //     },
  //   },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  // {
  //   value: PassportType.TempResidencePermit,
  //   label: {
  //     eng: 'Temp. residence permit',
  //     rus: 'РВП',
  //     kz: 'Уақытша тұруға рұқсат',
  //   },
  // },
  //   {
  //     value: PassportType.Passport,
  //     label: {
  //       eng: 'Internal passport',
  //       rus: 'Внутренний паспорт РФ',
  //       kz: 'Ішкі төлқұжат',
  //     },
  //   },
]
export const passportTypeRf: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Internal passport',
      rus: 'Внутренний паспорт РФ',
      kz: 'Ішкі төлқұжат',
    },
  },
]
export const passportTypeKgz: Option[] = [
  //   {
  //     value: PassportType.Passport,
  //     label: {
  //       eng: 'Biometric passport',
  //       rus: 'Биометрический паспорт',
  //       kz: 'Биометриялық төлқұжат',
  //     },
  //   },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  // {
  //   value: PassportType.TempResidencePermit,
  //   label: {
  //     eng: 'Temp. residence permit',
  //     rus: 'РВП',
  //     kz: 'Уақытша тұруға рұқсат',
  //   },
  // },
  //   {
  //     value: PassportType.IdCard,
  //     label: {
  //       eng: 'ID card',
  //       rus: 'ID карта',
  //       kz: 'Жеке куәлік',
  //     },
  //   },
]

export const passportTypeRom: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Simple electronic passport',
      rus: 'Простой электронный паспорт',
      kz: 'Қарапайым электрондық төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeGer: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeUsa: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'United States Passport',
      rus: 'Паспорт гражданина США',
      kz: 'АҚШ төлқұжаты ',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeTaj: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeTur: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Turkish Passport',
      rus: 'Турецкий паспорт',
      kz: 'Түрік төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeUzb: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const DocumentTypeValuesUdvAbroad: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const DocumentTypeValuesTypePersonalities: Option[] = [
  {
    value: PassportType.IdentityCard,
    label: {
      eng: 'Oud. personalities',
      rus: 'Уд. личности',
      kz: 'Оуд. тұлғалар',
    },
  },
]
export const DocumentTypeValuesTypePassport: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Passport',
      rus: 'Паспорт',
      kz: 'Паспорт',
    },
  },
]
